<template>
  <v-data-table :headers="headers" :items="items" :loading="loading" :options.sync="options" :server-items-length="meta.total">
    <template v-slot:top>
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" sm="3" class="mr-3">
            <v-text-field
              single-line
              hide-details
              dense
              label="Поиск"
              class="ma-0 pa-0"
              append-icon="mdi-magnify"
              @click:append="load"
              v-model="filter.search"
            />
          </v-col>

          <v-col cols="12" sm="3" class="mr-3">
            <date-range-picker label="Укажите дату С - До" v-model="filter.date" @input="load" dense />
          </v-col>

          <v-col cols="12" sm="3" class="mr-3">
            <v-select
              class="ma-0 pa-0"
              dense
              hide-details
              label="Статус"
              item-text="text"
              item-value="id"
              :items="statuses"
              v-model="filter.status"
              @change="load"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import throttle from "lodash/throttle";
import { QueryHelper } from "@/services/query-helper";
import { mapState } from "vuex";
import DateRangePicker from "@/components/forms/DateRangePicker";
import { MedicineService } from "@/services/api/medicine.service";

export default {
  name: "DrugsList",
  components: { DateRangePicker },
  data: () => ({
    loading: true,
    options: {},
    filter: {
      search: "",
      status: "",
      date: [],
    },
    statuses: [],
    headers: [
      { text: "Наименование", value: "name" },
      { text: "Способ приема", value: "method", align: "center" },
      { text: "Курс", value: "course", align: "center" },
      { text: "Период", value: "dates", align: "center" },
      { text: "Производитель", value: "manufacturer", align: "center" },
      { text: "", value: "actions", align: "center" },
    ],
  }),

  computed: {
    ...mapState("drugs", ["items", "meta"]),

    customerId() {
      return this.$store.state.customer.id;
    },
  },

  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },

  async created() {
    await this.loadFormData();
  },


  methods: {
    async loadFormData() {
      this.statuses = await MedicineService.getStatuses();
    },

    async load() {
      this.loading = true;

      const params = {
        search: this.search,
        ...QueryHelper.tableSorting(this.options),
        ...QueryHelper.filter(this.filter),
        ...QueryHelper.pagination(this.options, this.meta.total),
      };

      try {
        const response = await this.$http.get(`v1/customers/${this.customerId}/medicines`, { params }).then(r => r.data);
        this.$store.commit("drugs/SET_ITEMS", response.data);
        this.$store.commit("drugs/SET_META_TOTAL", response.meta.total);
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);

        this.$store.commit("drugs/SET_ITEMS", []);
        this.$store.commit("drugs/SET_META_TOTAL", 0);
      }

      this.loading = false;
    },

    apiSearch: throttle(async function apiSearchHandler() {
      await this.load();
    }, 1000),

    editItem(item) {},

    async deleteItem(item) {
      const title = item.title ? `"${item.title}"` : "";
      const result = await this.$dialog.confirm({
        title: "Удаление лекарства",
        text: `Вы подтверждаете удаление лекарства ${title}`,
      });

      if (result) {
        this.loading = true;
        const result = await this.$store.dispatch("drugs/removeItem", item);

        if (this.items.length === 0) {
          await this.load();
        }

        if (!result.success) {
          this.$dialog.notify.warning(result.message);
        }

        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
